export const UI_TEXT = {
  tabTitle: 'Configuration',
  tabSubtitlePrefix: 'Demo-only. Changes apply locally (no backend). Edge Controller ID:',
  telemetry: {
    title: 'Telemetry Synchronization',
    subtitle: 'Controls how often metrics are aggregated and uploaded.',
    enabledLabel: 'Enabled',
    disabledLabel: 'Disabled',
    aggregationIntervalLabel: 'Aggregation Interval (seconds)',
    aggregationIntervalHelper: 'Recommended: 30–120s for production.',
    metricSelectionLabel: 'Metric Selection',
    metricsLabel: 'Metrics',
    metricsPlaceholderAll: 'All metrics',
    metricsPlaceholderList: 'Select metrics',
    metricsEmptyError: 'Select at least one metric (or choose All metrics).',
    telemetryDisabledUsageLabel: 'Telemetry sync is disabled',
    telemetryDisabledUsageDetail: 'No periodic metric uploads.',
  },

  logging: {
    title: 'System & Component Logging',
    subtitle: 'Configure log verbosity and whether logs are replicated to the cloud.',
    replicationEnabledLabel: 'Cloud log streaming enabled',
    replicationDisabledLabel: 'Cloud log streaming disabled',
    globalLogLevelLabel: 'Global Log Level',
    perComponentTitle: 'Per-component log level',
    perComponentLogLevelLabel: 'Log Level',
    replicationDisabledUsageLabel: 'Cloud log streaming is disabled',
    replicationDisabledUsageDetail: 'Logs stay local on the edge controller.',
    debugUsageLabel: 'Higher usage expected (DEBUG enabled)',
    debugUsageDetail: 'Streaming verbose logs increases bandwidth and storage usage (demo hint).',
    moderateUsageLabel: 'Moderate usage expected',
    moderateUsageDetail: 'INFO/WARN/ERROR streaming is typically acceptable for production.',
  },

  events: {
    title: 'Event Reporting',
    subtitle: 'Configure which plaza events are collected and how often they are uploaded.',
    enabledLabel: 'Plaza events enabled',
    disabledLabel: 'Plaza events disabled',
    uploadIntervalLabel: 'Upload Interval (seconds)',
    uploadIntervalHelper: 'How often events are sent to the cloud.',
    eventTypesTitle: 'Event types',
    emptyError: 'Select at least one event type.',
    reportingDisabledUsageLabel: 'Event reporting is disabled',
    reportingDisabledUsageDetail: 'No plaza events will be uploaded.',
  },
};
